<order-request-main-order-list [orders]="transformedList"
  [article]="article"
  [workflow]="workflow"
  (updateParent)="update()">
</order-request-main-order-list>

@if (list) {
  <ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)">
  </ev-navigation>
}
